<br />
<ng-container *ngIf="ready == false">
  <br />
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
<ng-container *ngIf="ready">
  <convfact-deliverynote-form [deliverynote]="deliverynote" [concepts]="concepts" [contacts]="contacts" [accountsAndTaxes]="accountsAndTaxes"
    [bankAccounts]="bankAccounts" [userCompany]="userCompany" [accountings]="accountings" *ngIf="deliverynote" [errors]="errors" (onSave)="saveData($event)">  
  </convfact-deliverynote-form>
</ng-container>